import { render } from "./ToolbarOption.vue?vue&type=template&id=be1a216a"
import script from "./ToolbarOption.vue?vue&type=script&lang=js"
export * from "./ToolbarOption.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/ToolbarOption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be1a216a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be1a216a', __exports__)) {
    console.log('reload')
    api.reload('be1a216a', __exports__)
  }
  
  module.hot.accept("./ToolbarOption.vue?vue&type=template&id=be1a216a", () => {
    console.log('re-render')
    api.rerender('be1a216a', render)
  })

}


export default __exports__